"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Product = require("./Product");
Object.keys(_Product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Product[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Product[key];
    }
  });
});